$(function () {
    // setup forms
    $('.multistep-form').each(function (idx, form) {
        let $form = $(form),
            progressBtn = "<button class='form-progress-btn' type='button' data-step='' title=''></button>",
            prevBtn = "<button class='form-action-btn order-first' type='button' data-action='step' data-move='prev' data-step='' title='" + joelle_i18n.messages.previous + "'>" + joelle_i18n.messages.previous + "</button>",
            nextBtn = "<button class='form-action-btn order-last' type='button' data-action='step' data-move='next' data-step='' title='" + joelle_i18n.messages.next + "'>" + joelle_i18n.messages.next + "</button>",
            $steps = $form.find('fieldset');

        $form.find('.form-actions').append($(prevBtn)).append($(nextBtn));

        $form.navigate = function (step) {
            let $form = $(this),
                $step = $form.find('fieldset[data-step="' + step + '"]'),
                prevStep = $step.prev().attr('data-step'),
                nextStep = $step.next().attr('data-step');

            $form.find('[data-move="prev"]').attr('data-step', prevStep ?? '').attr('disabled', (prevStep ? null : 'disabled'));
            $form.find('[data-move="next"]').attr('data-step', nextStep ?? '').attr('disabled', (nextStep ? null : 'disabled'));

            $form.attr('data-current-step', step);

            $('.form-progress-btn').addClass('active').filter(function () {
                return parseInt($(this).attr('data-step')) > step;
            }).removeClass('active');

            $('fieldset.active').removeClass('active');
            $step.addClass('active');

            let offset = $form.parent().offset();
            $('html, body').animate({
                scrollTop: offset.top - 100
            });
        }

        $steps.each(function (idx, step) {
            let $step = $(step);

            // add step attr
            $step.attr('data-step', idx + 1);

            // add progress btn
            let stepProgress = $(progressBtn).attr('data-step', $step.attr('data-step')).attr('title', $step.data('title')).text($step.data('title'));
            $form.find('.form-progress').append(stepProgress);
        })

        // show the first step
        if ($form.attr('data-current-step') === undefined) {
            $form.navigate(1);
        }

        $('.form-progress-btn').on('click', (e) => {
            $form.navigate($(e.target).attr('data-step'));
        })

        $('[data-action="step"]').on('click', (e) => {
            let step = $(e.target).attr('data-step');

            if (step)
                $form.navigate(step);
        });
    });
})
